import React from "react";

import { CqWord } from "@/utils/word";
import { Button } from "@/components/ui/Button/Button";

interface IField {
  name?: string;
  label?: string;
  value: string;
}

const Field: React.FC<
  IField & {
    barName?: string;
    selected: string;
    selectValue: (value: string) => void;
  }
> = ({ name, barName, label, selected, selectValue, value }) => {
  return (
    <li
      className={`py-3 cursor-pointer hover:bg-gray-150 ${
        selected === value || selected === name
          ? "bg-gray-150 border-r-2 border-blue-700"
          : ""
      }`}
      onClick={() => {
        selectValue(value ?? name);
      }}
    >
      <div
        className={`flex items-center justify-between hover:text-blue-700 focus:text-blue-700 focus:outline-none ${
          selected === value || selected === name
            ? "text-blue-700 "
            : "text-gray-600"
        }`}
      >
        <div className="ml-3 leading-tighter select-none flex-1">
          {barName === "workflow" && value !== "basic" && "Workflow - "}
          {label}
        </div>
        <div>
          <Button
            className="ml-3"
            color="blue"
            onClick={() => {
              CqWord.addHtmlText(
                `\${renderIf('project.fields.${value}', '=', 'value','block_type_${value.replaceAll(
                  ".",
                  "_"
                )}')}<br />\${block_type_${value.replaceAll(
                  ".",
                  "_"
                )}} <br /> <br />\${/block_type_${value.replaceAll(".", "_")}} `
              );
            }}
            size="small"
          >
            If
          </Button>
          <Button
            className="ml-3"
            color="blue"
            onClick={() =>
              CqWord.addHtmlText(`\${value('project.fields.${value}')}`)
            }
            size="small"
          >
            Value
          </Button>
        </div>
      </div>
    </li>
  );
};

export default Field;
